import { InjectionToken } from '@angular/core';
import { RuntimeConfig } from '@common/util-models';

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>(
  'Config that changes per Deployment Environment'
);
